var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 8,
    viewBox: "0 0 73 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9414 3.17332C23.2833 3.17332 31.6274 2.40041 39.9941 2.30961C46.47 2.23932 52.9151 2.04264 59.3969 2.04264C60.2511 2.04264 66.6751 1.838 62.9523 2.32531C52.9282 3.63744 43.1814 5.15199 32.8008 5.15199C25.0695 5.15199 17.4597 5.24631 9.75998 5.45037C7.56024 5.50866 5.25431 5.60816 3.06272 5.73304C1.04546 5.84798 2.32439 5.73965 3.42101 5.71733C10.2643 5.57807 17.2533 5.61315 24.0916 5.73304C29.0827 5.82054 34.028 6 39.0295 6C46.197 6 53.3003 5.43466 60.4718 5.43466C64.0477 5.43466 67.4729 5.15199 71 5.15199",
    stroke: "#ECFAF9",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineBig);
export default __webpack_public_path__ + "static/media/underline-big.6577326cf3041663dd7be15caa5fa8e6.svg";
export { ForwardRef as ReactComponent };